import type { ReactNode } from 'react'
import { HOUSES, VENDORS } from '../../config/competition'

/** Small square-cornered label. Tone drives the border and ink, never a fill. */
export function Chip({
  children,
  tone = 'neutral',
  color,
  title,
}: {
  children: ReactNode
  tone?: 'neutral' | 'up' | 'down' | 'warn' | 'accent'
  color?: string
  title?: string
}) {
  const style = color ? { color, borderColor: color } : undefined
  return (
    <span className={`chip chip--${tone}`} style={style} title={title}>
      {children}
    </span>
  )
}

export function HouseTag({ house }: { house: string }) {
  const h = HOUSES[house]
  if (!h) return null
  return (
    <span className="htag" style={{ color: h.color, borderColor: h.color }}>
      {h.name}
    </span>
  )
}

export function VendorTag({ vendor }: { vendor: string }) {
  const v = VENDORS[vendor]
  if (!v) return null
  return (
    <span className="vtag" data-vendor={vendor}>
      {v.short}
    </span>
  )
}

/** Ten-segment conviction readout. Discrete on purpose: it is a claim, not a measurement. */
export function Conviction({ value, color }: { value: number; color?: string }) {
  const filled = Math.round(Math.max(0, Math.min(1, value)) * 10)
  return (
    <span className="conv" title={`conviction ${(value * 100).toFixed(0)}%`}>
      {Array.from({ length: 10 }, (_, i) => (
        <i
          key={i}
          className={`conv__seg ${i < filled ? 'is-on' : ''}`}
          style={i < filled && color ? { background: color } : undefined}
        />
      ))}
    </span>
  )
}

export function LiveDot({ status }: { status: string }) {
  return <span className={`ldot ldot--${status}`} aria-hidden="true" />
}
